import $ from "jquery";

const init = () => {
  observeElement();
};

const observeElement = () => {
  if (!$(".mi-woocommerce-cart").length) return;

  const btn = document.querySelector(".mi-woocommerce-cart");
  const options = {
    childList: true,
    subtree: true,
  };

  // eslint-disable-next-line no-unused-vars
  function callback(mutationList, observer) {
    // eslint-disable-line
    mutationList.forEach(function () {
      getTotalItem();
    });
  }

  const observer = new MutationObserver(callback);
  observer.observe(btn, options);
};

function getTotalItem() {
  let arr = [];

  $(".wqpmb_input_text").each(function () {
    let currentElement = $(this);
    arr.push(Number(currentElement.attr("value")));
  });

  let cartTotal = arr.reduce((a, b) => a + b, 0);
  $(".cart-count").text(cartTotal);
}

try {
  init();
} catch (error) {
  console.warn(error);
}
